module.exports = __webpack_public_path__ + "static/media/idun2.074d249c.JPG";